import { render, staticRenderFns } from "./Congresses.vue?vue&type=template&id=402e98a0&scoped=true&"
import script from "./Congresses.vue?vue&type=script&lang=js&"
export * from "./Congresses.vue?vue&type=script&lang=js&"
import style0 from "./Congresses.vue?vue&type=style&index=0&id=402e98a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402e98a0",
  null
  
)

export default component.exports